import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { ToastsManager } from 'ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Product } from '../../../models/billing-letter/Product.model';
import { ProductService } from './../../../services/product.service';
import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../../services/aws.service';
import { CompaniesService } from '../../../services/companies.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';

@Component({
  selector: 'app-products-edit',
  templateUrl: './products-edit.component.html',
  styleUrls: ['./products-edit.component.css']
})
export class ProductEditComponent implements OnInit {
    editProductCheck: boolean = false;
    loading: boolean = false;
    productForm: FormGroup;
    fileList;
    selectedFiles:FileList;
    id;
    downloadUrl:string = '';
    commonHelper: CommonHelper = new CommonHelper();

    product: Product = new Product();

  constructor(private productService: ProductService,
                private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                public toastr: ToastsManager,
                private awsService:AwsService,
                ) { }

  async ngOnInit() {
    this.loading = true;
    this.productForm = this.formBuilder.group({
        name: [null, Validators.required],
        licenseType: [null, Validators.required],
        secondarylicenseType: [null, Validators.required],
        endCustomerType: [null, Validators.required],
        material: [null, Validators.required]
      });

    const product = await this.productService.getById(this.route.snapshot.params['id']);

    this.product = product;

    this.loading = false;
  }

  onChange() {
      if (!this.loading) {
        if (this.productForm.valid) {
                this.editProductCheck = true;
            } else {
                this.editProductCheck = false;
            }
        }
   }

   edit() {

    try {
      this.productService.update(this.product);
      this.router.navigate(['/products']);
      this.toastr.success('Produto alterado com sucesso!');
    } catch(err) {
      this.router.navigate(['/products']);
      this.toastr.warning('Erro Salvar Produto!')
    }
   }

   OnCancel() {
    this.router.navigate(['/products']);
   }

   verifyValidTouched(fieldName) {
    return !this.productForm.get(fieldName).valid && this.productForm.get(fieldName).touched;
  }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/products/products-edit/products-edit.component.ts